import {
  Typography,
  Checkbox,
  FormControl,
  FormControlLabel,
  Container,
  Button,
  Modal,
  Box,
} from "@mui/material";

import { useParams } from "react-router-dom";
import {
  deleteDoc,
  getDoc,
  doc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";

import { db } from "../firebase.config";
import { toast } from "react-toastify";

import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditTierListContainer from "../components/EditTierListContainer";
import Spinner from "../components/Spinner.jsx";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function EditDraft(props) {
  const { appState, setAppState } = props;
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const params = useParams();

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    const fetchDraft = async () => {
      try {
        setLoading(true);
        // Get Reference

        const tierListDraftRef = doc(db, "tierLists", params.draftId);
        const tierListDraftDocSnap = await getDoc(tierListDraftRef);
        const tierListData = tierListDraftDocSnap.data();

        // update state here
        setAppState((prevState) => ({
          ...prevState,
          fetchedDraft: tierListData,
        }));

        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
        toast.error("Could not fetch Tier List");
      }
    };
    fetchDraft();
    // }, []);
  }, [params.draftId, navigate, setAppState]);

  const saveChanges = async (e) => {
    try {
      e.preventDefault();
      console.log("save changes ran");
      setLoading(true);

      const tierListCopy = {
        ...appState.fetchedDraft,
        timestamp: serverTimestamp(),
      };

      // Update Tier List
      const docRef = doc(db, "tierLists", params.draftId);
      console.log("docRef :", docRef);
      await updateDoc(docRef, tierListCopy);

      setLoading(false);
      toast.success("Tier List saved");
      navigate(`/tierlist/${docRef.id}`);
    } catch (error) {
      console.log("error :", error);
      setLoading(false);
      toast.error("Could not update tier list");
    }
  };
  const changeDraft = (e) => {
    console.log("Change draft");
    setAppState((prevState) => ({
      ...prevState,
      fetchedDraft: {
        ...prevState.fetchedDraft,
        draft: !prevState.fetchedDraft.draft,
      },
    }));
  };

  const deleteTierList = (e) => {
    e.preventDefault();
    handleOpen();
  };

  const modalSubmit = async (e) => {
    e.preventDefault();
    const ans = document.activeElement["value"];
    if (ans === "yes") {
      console.log('ans ==="yes"');
      console.log("delete this list");
      const tierListDraftRef = doc(db, "tierLists", params.draftId);
      await deleteDoc(tierListDraftRef);
      navigate("/create");

      handleClose();
    } else if (ans === "no") {
      console.log('ans ==="no"');
      handleClose();
    }
    console.log("modalSubmitted");
  };

  return (
    <Container>
      Edit Tier list {params.draftId}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            // Text in a modal
          >
            {" "}
            Confirm Deletion?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Deleting TierList id: {params.draftId}
            <form
              onSubmit={(e) => {
                modalSubmit(e);
              }}
            >
              <Button
                type="submit"
                variant="contained"
                sx={{ textTransform: "none" }}
                color="success"
                value="yes"
              >
                Yes
              </Button>
              <Button
                type="submit"
                variant="contained"
                sx={{ textTransform: "none" }}
                color="error"
                value="no"
              >
                No
              </Button>
            </form>
          </Typography>
        </Box>
      </Modal>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <EditTierListContainer
            appState={appState}
            setAppState={setAppState}
          />
          <form onSubmit={saveChanges}>
            <FormControl>
              <FormControlLabel
                control={<Checkbox />}
                label="Is draft?"
                checked={appState.fetchedDraft?.draft}
                onChange={changeDraft}
              />
            </FormControl>
            <FormControl>
              <Button
                type="submit"
                variant="contained"
                sx={{ textTransform: "none" }}
              >
                Save Changes
              </Button>
            </FormControl>
          </form>
          <form onSubmit={deleteTierList}>
            <Button variant="contained" color="error" type="submit">
              <DeleteOutlineIcon /> Delete
            </Button>
          </form>
        </>
      )}
    </Container>
  );
}

export default EditDraft;
